import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "items", "wrap", "getItemColor", "getItemIcon", "getItemImage", "getItemLogo", "getItemName", "getItemTagName", "getItemAttributes", "getItemDisabled", "getItemRef", "getItemInvert", "getItemBgColor", "getItemCustomColors", "visibleCount", "size", "disabled"];
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { Avatar } from "../Avatar";
import { composePreparedProps, getAvatarProps } from "./utils";
import styles from "./styles.pcss";
import { useVisibleItems } from "./hooks/useVisibleItems";
var cnAvatarGroup = cnBem('avatar-group', styles);
var AvatarGroupRender = function AvatarGroupRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    className = _composePreparedProps.className,
    _composePreparedProps2 = _composePreparedProps.items,
    items = _composePreparedProps2 === void 0 ? [] : _composePreparedProps2,
    wrap = _composePreparedProps.wrap,
    getItemColor = _composePreparedProps.getItemColor,
    getItemIcon = _composePreparedProps.getItemIcon,
    getItemImage = _composePreparedProps.getItemImage,
    getItemLogo = _composePreparedProps.getItemLogo,
    getItemName = _composePreparedProps.getItemName,
    getItemTagName = _composePreparedProps.getItemTagName,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemRef = _composePreparedProps.getItemRef,
    getItemInvert = _composePreparedProps.getItemInvert,
    getItemBgColor = _composePreparedProps.getItemBgColor,
    getItemCustomColors = _composePreparedProps.getItemCustomColors,
    visibleCount = _composePreparedProps.visibleCount,
    _composePreparedProps3 = _composePreparedProps.size,
    size = _composePreparedProps3 === void 0 ? 'm' : _composePreparedProps3,
    disabled = _composePreparedProps.disabled,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var _useVisibleItems = useVisibleItems(items, size, visibleCount),
    parentRef = _useVisibleItems.parentRef,
    hiddenCount = _useVisibleItems.hiddenCount,
    visibleItems = _useVisibleItems.visibleItems;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnAvatarGroup({
      wrap: wrap,
      size: size
    }, [className]),
    ref: combineRefs([ref, parentRef])
  }, otherProps, {
    "data-t-id": "components-AvatarGroup"
  }), visibleItems.map(function (item, i) {
    var _getItemDisabled, _getItemAttributes;
    return /*#__PURE__*/React.createElement(Avatar, _extends({
      className: cnAvatarGroup('item'),
      disabled: (_getItemDisabled = getItemDisabled(item)) !== null && _getItemDisabled !== void 0 ? _getItemDisabled : disabled,
      key: cnAvatarGroup('item', {
        i: i
      }),
      ref: getItemRef(item),
      size: size,
      tagName: getItemTagName(item)
    }, getAvatarProps(item, {
      getItemInvert: getItemInvert,
      getItemIcon: getItemIcon,
      getItemImage: getItemImage,
      getItemLogo: getItemLogo,
      getItemCustomColors: getItemCustomColors,
      getItemName: getItemName,
      getItemColor: getItemColor,
      getItemBgColor: getItemBgColor
    }), (_getItemAttributes = getItemAttributes(item)) !== null && _getItemAttributes !== void 0 ? _getItemAttributes : {}));
  }), hiddenCount > 0 && /*#__PURE__*/React.createElement(Avatar, {
    className: cnAvatarGroup('item'),
    disabled: disabled,
    name: "+".concat(hiddenCount),
    size: size
  }));
};
export var AvatarGroup = /*#__PURE__*/forwardRef(AvatarGroupRender);